import { Div2Floor } from "../utils/Div2Floor";
import { enumUIColors, kMinTrips, kNumSegments } from "../constants";
import { uViewerButtonColor, enumButtonColors } from "../whitelabel/brand";
import { QElement } from "./QElement";
import { Globals } from "./Globals";

export class QLoadingElement extends QElement {
  constructor() {
    super();
    this.fSegment = 1;
    this.fTrip = 0;
    this.fWSMgr = null;
    this.fRadius = 30;
  }

  InitIntro(wsMgr) {
    var color = enumUIColors["Default"][0];
    if (
      localStorage.uicolor == enumUIColors["Blue Gray"][0] &&
      localStorage.buttoncolor == "#FFFFFF"
    ) {
      delete localStorage.uicolor; // TO-DO DELETE THIS WHOLE BLOCK
      delete localStorage.buttoncolor;
    }
    var uiColor = localStorage.uicolor;
    if (uiColor) color = uiColor;
    var buttonColor = enumButtonColors[uViewerButtonColor];
    if (Globals._accountInfo.GetButtonColor()) buttonColor = Globals._accountInfo.GetButtonColor();
    var cachedColor = localStorage.buttoncolor;
    if (cachedColor) buttonColor = cachedColor;
    this.fThemeColor = uiColor;
    this.fLoadingSegmentColor = buttonColor;
    this.SetAcceptsClicks(false);
    this.SetFillColor(color);
    this.fWSMgr = wsMgr;
  } //8;
  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");

    var strokeStyle = this.fWSMgr ? this.fLoadingSegmentColor : this.fLoadingSegmentColor;
    var fillStyle = this.fWSMgr ? this.fLoadingSegmentColor : this.fLoadingSegmentColor;

    var x = this.GetPositionX();
    var y = this.GetPositionY();
    var xC = x + Div2Floor(this.GetWidth()); //Math.floor(this.GetWidth()/2);
    var yC = y + Div2Floor(this.GetHeight()); // Math.floor(this.GetHeight()/2);
    var innerR = this.fRadius;
    var outerR = innerR + 7;

    var segments = kNumSegments;
    var startAngle = 0;
    var segRadians = (2 * Math.PI) / segments;
    var segGap = (2 * Math.PI) / 52;

    for (var i = 0; i < segments; i++) {
      var sa = startAngle;
      var ea = sa + segRadians - segGap;
      ctx.strokeStyle = "miter";
      ctx.save();
      ctx.beginPath();
      ctx.arc(xC, yC, innerR - 1, sa, sa);
      ctx.arc(xC, yC, outerR + 1, sa, ea);
      ctx.arc(xC, yC, innerR + 1, ea, ea);
      ctx.arc(xC, yC, innerR - 1, ea, sa, true);
      ctx.closePath();
      ctx.lineWidth = 1;
      ctx.strokeStyle = strokeStyle;

      ctx.stroke();
      ctx.globalAlpha = 0.4 / Math.abs(this.fSegment - i);

      ctx.fillStyle = fillStyle;
      ctx.fill();

      ctx.restore();
      startAngle = startAngle + segRadians;
    }
  }

  DoTimerFire(timerDone) {
    this.fSegment++;
    //console.log("QLoadingElement:DoTimerFire", this.fSegment);
    if (this.fSegment >= kNumSegments) {
      this.fSegment = 0;
      this.fTrip++;
      if (this.fTrip >= kMinTrips) {
      }
    }
    var msgCanvas = document.getElementById("msgcanvas");
    if (msgCanvas) {
      //TODO: Something is wrong here with the timer. It looks like its drawing over itself.
      this.DoRenderElement(msgCanvas);
    }
  }
}
